<template>
	<div
		v-if="showOk"
		class="rounded-circle bg-primary-500 d-flex justify-center align-center"
		:style="{ width: '40px', height: '40px' }"
	>
		<Icon icon="check-simple" class="text-neutral-25" width="20px" height="20px" />
	</div>
	<div
		v-else
		class="rounded-circle bg-neutral-100 d-flex justify-center align-center"
		:style="{ width: '40px', height: '40px' }"
	>
		<Icon :icon="icon" class="text-primary-700" width="20px" height="20px" />
	</div>
</template>
<script setup lang="ts">
	interface Props {
		showOk: boolean
		icon: string
	}

	defineProps<Props>()
</script>
